export const getProductName = (record) => {
    let productName = '';
    if(record?.inwardXflow) 
        productName+= 'Xflow-Inward '
    if(record?.outwardYes)
        productName+= 'Yes-Outward '
    if(record?.outwardIDFC)
        productName+= 'Idfc-Outward '
    if(record?.inwardYes)
        productName+= 'Yes-Inward '
    if(record?.inwardIDFC)
        productName+= 'Idfc-Inward '
    if(record?.outwardRBL)
        productName+= 'RBL-Outward '
    if(record?.outwardDBS)
        productName+= 'DBS-Outward '
    if(record?.inwardRBL)
        productName+= 'RBL-Inward '
    if(record?.inwardDBS)
        productName+= 'DBS-Inward '
    if(record?.inwardPayglocal)
        productName+= 'Payglocal-Inward '

    return productName ? productName : '-----'

}